module.exports = __webpack_public_path__ + "static/media/icon-offer.f75df3ba.svg";